import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { getCostcodeByIds } from './state/costcodes.actions';

export default function useUpdateCostcodeIdMap({
  items,
  columns,
}) {
  const dispatch = useDispatch();
  const costcodeIds = useMemo(() => (
    Array.from(
      new Set(items?.map((task) => task?.costcodeId) ?? []),
    ).filter(Boolean)
  ), [items]);
  const columnsKey = useMemo(
    () => [...(columns || [])]
      .sort((a, b) => String(a).localeCompare(String(b)))
      .join(','),
    [columns],
  );
  useEffect(() => {
    if (!costcodeIds.length) return;
    dispatch(getCostcodeByIds(
      costcodeIds,
      columnsKey ? { columns: columnsKey.split(',') } : {},
    ));
  }, [costcodeIds, columnsKey]);
}
